// extracted by mini-css-extract-plugin
export default {"carrouselLowerCon":"dotsCarrousel_carrouselLowerCon__J1XRv","dotLowerCon":"dotsCarrousel_dotLowerCon__+9ony","activeClassDot":"dotsCarrousel_activeClassDot__e5YGe"};